function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &.ant-card.ant-card {\n    box-shadow: none;\n  }\n\n  &.ant-card.ant-card-bordered {\n    border-color: #d9d9d9;\n  }\n\n  & > .ant-card-actions {\n    padding: 12px 16px;\n    border-color: #d9d9d9;\n  }\n\n  & > .ant-card-actions > li {\n    text-align: left;\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Selected fonts are successfully added!"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  // undo left shift for full width\n  & > .ant-input-group > .ant-input-group-addon:last-child {\n    left: 0;\n  }\n  // remove extra border from input end adornment\n  & > .ant-input-group > .ant-input-group-addon:last-child > .ant-btn-icon-only {\n    border-left: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 7px;\n  background-color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-right: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Max limit: 10 fonts"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Total: ",
        " fonts"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Font Library"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Add to list"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Search"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Selected Fonts"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import React, { memo, useState, useMemo, useEffect, useCallback } from "react";
import { t } from "ttag";
import styled from "styled-components";
import { debounce } from "lodash";
import { areEqual, FixedSizeList as VList } from "react-window";
import { Card as AntdCard, Col, Modal, Row, Input, List, Spin, Typography, Tooltip, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import localforage from "localforage";
import useBunnyFonts, { FONT_STATUS_LOADING, FONT_STATUS_LOADED, FONT_STATUS_FAILED } from "@eventmobi/rich-text/useBunnyFonts";
// @ts-ignore
import { EXTRA_FONTS } from "@eventmobi/rich-text/fonts";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var FONTS_STORAGE_KEY = "CUSTOM_FONTS_EXP";
var Card = styled(AntdCard)(_templateObject());
export var useFonts = function() {
    var _useState = _slicedToArray(useState(false), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = _slicedToArray(useState([]), 2), fonts = _useState1[0], setFonts = _useState1[1];
    useEffect(function() {
        var effect = function() {
            var _ref = _asyncToGenerator(function() {
                var storedFonts;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                localforage.getItem(FONTS_STORAGE_KEY)
                            ];
                        case 1:
                            storedFonts = _state.sent();
                            if (storedFonts === null || storedFonts === void 0 ? void 0 : storedFonts.length) {
                                setFonts(storedFonts);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function effect() {
                return _ref.apply(this, arguments);
            };
        }();
        effect();
    }, []);
    var updateFonts = useCallback(function() {
        var _ref = _asyncToGenerator(function(newFonts) {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFonts(newFonts);
                        setVisible(false);
                        message.success(t(_templateObject1()));
                        return [
                            4,
                            localforage.setItem(FONTS_STORAGE_KEY, newFonts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newFonts) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        visible: visible,
        fonts: fonts,
        setVisible: setVisible,
        updateFonts: updateFonts
    };
};
var AntdSearch = Input.Search;
var Text = Typography.Text;
var Search = styled(AntdSearch)(_templateObject2());
var FontItem = styled(List.Item)(_templateObject3(), function(props) {
    return props.$isSelected ? "#E6F7FF" : "auto";
});
var SuccessIcon = styled(FontAwesomeIcon)(_templateObject4(), function(props) {
    return props.icon === faExclamationCircle ? "#F44336" : "#52C41A";
});
var MAX_FONTS = 10;
var SELECTED_TEXT_COLOR = "#1890FF";
var Font = /*#__PURE__*/ memo(function(param) {
    var font = param.font, onClick = param.onClick, actions = param.actions, style = param.style;
    var fonts = useMemo(function() {
        return [
            font
        ];
    }, [
        font
    ]);
    var status = useBunnyFonts(fonts).status;
    return /*#__PURE__*/ React.createElement(FontItem, {
        style: _objectSpread({}, style),
        onClick: function() {
            return onClick(font);
        },
        actions: actions
    }, status === FONT_STATUS_LOADING && /*#__PURE__*/ React.createElement(Spin, {
        size: "small"
    }), status === FONT_STATUS_LOADED && /*#__PURE__*/ React.createElement(Text, {
        style: {
            fontFamily: font
        }
    }, font), status === FONT_STATUS_FAILED && /*#__PURE__*/ React.createElement(Text, null, font));
}, areEqual);
// eslint-disable-next-line react/no-multi-comp
var Item = /*#__PURE__*/ memo(function(param) {
    var index = param.index, data = param.data, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style;
    var list = data.list, actions = data.actions, selected = data.selected, _data_onClick = data.onClick, onClick = _data_onClick === void 0 ? function() {} : _data_onClick;
    var font = list[index];
    var isSelected = (selected === null || selected === void 0 ? void 0 : selected.indexOf(font)) >= 0 || false;
    if (isSelected) {
        return /*#__PURE__*/ React.createElement(FontItem, {
            style: _objectSpread({}, style),
            $isSelected: true,
            onClick: function() {
                return onClick(font);
            },
            actions: [
                /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faCheck,
                    style: {
                        color: SELECTED_TEXT_COLOR
                    }
                })
            ]
        }, /*#__PURE__*/ React.createElement(Text, {
            style: {
                fontFamily: font,
                color: SELECTED_TEXT_COLOR
            }
        }, font));
    }
    return /*#__PURE__*/ React.createElement(Font, {
        font: font,
        style: style,
        onClick: onClick,
        actions: actions
    });
}, areEqual);
var Footer = function(param) {
    var selected = param.selected;
    var status = selected.length > MAX_FONTS;
    return /*#__PURE__*/ React.createElement(Tooltip, {
        title: t(_templateObject5()),
        placement: "right"
    }, /*#__PURE__*/ React.createElement(Text, null, /*#__PURE__*/ React.createElement(SuccessIcon, {
        icon: status ? faExclamationCircle : faCheckCircle
    }), t(_templateObject6(), selected.length)));
};
var Fonts = function(param) {
    var onClose = param.onClose, fonts = param.fonts, onSave = param.onSave;
    var _useState = _slicedToArray(useState(EXTRA_FONTS), 2), list = _useState[0], setList = _useState[1];
    var _useState1 = _slicedToArray(useState(fonts), 2), selected = _useState1[0], setSelected = _useState1[1];
    var onSearch = debounce(function(val) {
        if (!val) {
            setList(EXTRA_FONTS);
        }
        setList(EXTRA_FONTS.filter(function(f) {
            return f.toLowerCase().includes(val.toLowerCase());
        }));
    });
    var removeFont = function(font) {
        return setSelected(selected.filter(function(f) {
            return f !== font;
        }));
    };
    var itemData = useMemo(function() {
        return {
            onClick: function(f) {
                if (selected.indexOf(f) < 0) {
                    setSelected(_toConsumableArray(selected).concat([
                        f
                    ]));
                } else {
                    removeFont(f);
                }
            },
            selected: selected,
            list: list,
            actions: []
        };
    }, // TODO Remove the eslint-disable and fix the problem
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        selected,
        list
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        bodyStyle: {
            padding: "16px"
        },
        width: 800,
        visible: true,
        destroyOnClose: true,
        onOk: function() {
            onSave(selected);
        },
        onCancel: onClose,
        title: t(_templateObject7()),
        okText: t(_templateObject8()),
        okButtonProps: {
            disabled: selected.length > MAX_FONTS
        }
    }, /*#__PURE__*/ React.createElement(Row, {
        gutter: 11
    }, /*#__PURE__*/ React.createElement(Col, {
        span: 16
    }, /*#__PURE__*/ React.createElement(Search, {
        placeholder: t(_templateObject9()),
        onSearch: onSearch,
        allowClear: true
    }), /*#__PURE__*/ React.createElement(List, {
        bordered: true,
        style: {
            marginTop: "8px"
        }
    }, /*#__PURE__*/ React.createElement(VList, {
        height: 334,
        itemCount: list.length,
        itemSize: 48,
        width: "100%",
        itemData: itemData
    }, Item))), /*#__PURE__*/ React.createElement(Col, {
        span: 8
    }, /*#__PURE__*/ React.createElement(Card, {
        title: t(_templateObject10()),
        bodyStyle: {
            padding: 0,
            height: 270,
            overflowY: "auto"
        },
        actions: [
            /*#__PURE__*/ React.createElement(Footer, {
                selected: selected
            })
        ],
        headStyle: {
            color: "#262626",
            padding: "0 16px",
            borderColor: "#d9d9d9"
        }
    }, /*#__PURE__*/ React.createElement(List, null, selected.map(function(font, index) {
        return /*#__PURE__*/ React.createElement(Item, {
            index: index,
            data: {
                list: selected,
                actions: [
                    /*#__PURE__*/ React.createElement(CloseOutlined, {
                        style: {
                            fontSize: "9px"
                        },
                        onClick: function() {
                            return removeFont(selected[index]);
                        }
                    })
                ]
            },
            style: {
                backgroundColor: "#FAFAFA"
            },
            key: "".concat(font, "-selected")
        });
    }))))));
};
export default Fonts;
